// extracted by mini-css-extract-plugin
export default {"container":"CustomRadarChart_container__jhHrR","innerContainer":"CustomRadarChart_innerContainer__BogGW","chart":"CustomRadarChart_chart__s5Yzs"};